import { Component, OnInit } from '@angular/core';
import { AppMetadataHandler } from 'app';

@Component({
  selector: 'app-under-writer-dashboard',
  templateUrl: './under-writer-dashboard.component.html',
  styleUrls: ['./under-writer-dashboard.component.scss']
})
export class UnderWriterDashboardComponent implements OnInit {

  constructor(public appMetadataHandler: AppMetadataHandler) {

  }
  dashboardDateRange: any = [];
  dateRangeUnderwriterScreenBoard: any = null;
  currentMonth: string;

  ngOnInit() {
    this.setDefaultDateRange();
    this.currentMonth = this.getCurrentMonth();
  }

  getCurrentMonth(): string {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const now = new Date();
    return months[now.getMonth()];
  }



  setDefaultDateRange() {
    var currentDate = new Date();
    var PreviousYrDate = currentDate.setFullYear(currentDate.getFullYear() - 1);
    this.dashboardDateRange = [new Date(PreviousYrDate), new Date()];
  }
  widgetReady: boolean = false;
  monthlyOrWeekly: string = 'monthly';
  calculateAndGetPercentage(value, outOff){
    return Math.round(value / outOff * 100)
  }
  underwriterBoard = [
    {
      "LOB": "NBU-Health",
      "totalCases": 3190,
      "STP": 1830,
      "NSTP": 360,
      "pending": 580,
      "rated": 300,
      "declined": 220
    },
    {
      "LOB": "NBU-Life",
      "totalCases": 3190,
      "STP": 1830,
      "NSTP": 360,
      "pending": 580,
      "rated": 300,
      "declined": 220
    },
    {
      "LOB": "Claim-Health",
      "totalCases": 3190,
      "STP": 1830,
      "NSTP": 360,
      "pending": 580,
      "rated": 300,
      "declined": 220
    }
  ]


  productLobAnalysis = [
    {
      "LOB": "Health",
      "product": "Standard Health Care",
      "productID": "SHC012",
      "issuedPolicyRatio": 31,
      "referredPolicyRatio": 3,
      "rejectedPolicyRatio": 4,
      "SLABreachingRatio": 1
    },
    {
      "LOB": "Health",
      "product": "Hospital Benefit Plus",
      "productID": "HBP09",
      "issuedPolicyRatio": 23,
      "referredPolicyRatio": 6,
      "rejectedPolicyRatio": 2,
      "SLABreachingRatio": 6
    },
    {
      "LOB": "Life",
      "product": "Life Assurance Plus",
      "productID": "LAP00",
      "issuedPolicyRatio": 20,
      "referredPolicyRatio": 2,
      "rejectedPolicyRatio": 2.5,
      "SLABreachingRatio": 4
    }
  ]

  chart = [
    {
      "name": "STP",
      "series": [
        {
          "name": "Jan",
          "value": 500
        },
        {
          "name": "Feb",
          "value": 300
        },
        {
          "name": "March",
          "value": 500
        }
      ]
    },

    {
      "name": "NSTP",
      "series": [
        {
          "name": "Jan",
          "value": 200
        },
        {
          "name": "Feb",
          "value": 100
        },
        {
          "name": "March",
          "value": 200
        }
      ]
    }
  ];
  colorScheme = {
    domain: ["#647c8a", "#3f51b5", "#2196f3", "#00b862", "#85a711", "#b1bd0d", "#5797cb", "#d276be", "#ac4632", "#0ba3d4", "#647c8a", "#3f51b5", "#2196f3", "#00b862", "#85a711", "#b1bd0d"]
  };

  ageGroupGradient: boolean = true;
  ageGroupShowLegend: boolean = true;
  ageGroupShowLabels: boolean = true;
  legendPosition: string = 'below';
  isDoughnut: boolean = false;
  ageGroupChart = [
    {
      "name": ">20",
      "value": 30
    },
    {
      "name": "21 - 40",
      "value": 30
    },
    {
      "name": "41 - 60",
      "value": 35
    },
    {
      "name": "61 - 75",
      "value": 3
    },
    {
      "name": ">76",
      "value": 2
    }
  ];
  declineReasonChart = [
    {
      "name": "R1",
      "value": 50
    },
    {
      "name": "R2",
      "value": 35
    },
    {
      "name": "R3",
      "value": 10
    },
    {
      "name": "R4",
      "value": 3
    },
    {
      "name": "Others",
      "value": 2
    }
  ];

  ruleTableData = [
    {
      "LOB": "Health",
      "productName": "Standard Health Insurance",
      "productID": "SHI09",
      "ruleName": "Smoker and alcoholic",
      "failingRatio": 32
    },
    {
      "LOB": "Health",
      "productName": "Hospital Benefit Plus",
      "productID": "HBP009",
      "ruleName": "Existing Disease",
      "failingRatio": 38
    }
  ];
  slaData = [
    {
      "name": "Achieved",
      "value": 80
    },
    {
      "name": "Missed",
      "value": 20
    }
  ];
  timelineData = [
    { title: 'SLA is not achieved', description: 'TAT is more than SLA', progress: 25, color: '#FF5733' },//red
    { title: 'SLA is about to breach', description: 'Last one hour to complete the task', progress: 40, color: '#FFC300' }, //amber
    { title: 'on-time delivery can be achieved', description: '4 hours pending to complete the task', progress: 70, color: '#52BE80 ' }, //grren

  ];


  loading = false;


  items = [
    { id: 1, text: 'Obama Romi', icon: 'user' },
    { id: 2, text: 'Den D', icon: 'user' },
    { id: 3, text: 'Christan Joseph', icon: 'user' },
    { id: 4, text: 'Jin Jincy', icon: 'user' },
  ];



}